module.exports = __webpack_public_path__ + "img/vidalink.09facf95.png";